import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const errorBoundary = css`
  display: flex;
  justify-content: center;
  margin-top: 3.75rem;

  @media (max-width: ${dimensions.tabletMax}) {
    margin-top: 2rem;
  }

  @media (min-width: ${dimensions.breakpoints.fullHD.min + 64}px) {
    margin: 3.75rem auto 0;
    width: 100%;
  }
`;

export const content = css`
  padding: 0 1rem;
`;

export const title = (theme: Theme) => css`
  &&& {
    color: ${theme.primary.backgroundBase};
    font-weight: bold;
    font-size: 3.5rem;
  }
`;

export const subTitleContainer = css`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
`;

export const text = css`
  max-width: 27rem;
  margin-bottom: 1rem;
`;

export const logo = css`
  height: 1.125rem;
  width: auto;
  margin-right: 1rem;
`;
